module.exports = __webpack_public_path__ + "static/media/p4.243b42b9.png";